export default function filterArray(target: unknown[]) {
  return target.filter(Boolean);
}
